import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export interface SafeReturnWatcher {
    watcherId: number;
    watcherUserNo: number;
    watcherNickname: string;
    watcherProfileUrl: string | null;
    status: 'INVITED' | 'ACCEPTED' | 'DECLINED';
    respondedAt: string | null;
}

export interface SafeReturnSessionResponse {
    sessionId: number;
    meetingId: string;
    travelerUserNo: number;
    travelerNickname: string;
    travelerProfileUrl: string | null;
    destAddress: string;
    destLat: number;
    destLng: number;
    destRadiusM: number;
    status: 'ACTIVE' | 'ARRIVED' | 'EXPIRED' | 'DEAD_MAN' | 'CANCELLED';
    startedAt: string;
    expiresAt: string;
    arrivedAt: string | null;
    endedAt: string | null;
    lastLat: number | null;
    lastLng: number | null;
    lastLocationAt: string | null;
    maxDurationMin: number;
    watchers: SafeReturnWatcher[];
}

export interface CreateSafeReturnSessionPayload {
    meetingId: string;
    destLat: number;
    destLng: number;
    destAddress: string;
    destRadiusM?: number;
    watcherUserNos: number[];
}

export class SafeReturnRepository {
    // 세션 생성 (귀가자)
    static onCreateSession = (payload: CreateSafeReturnSessionPayload) => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/sessions`,
            method: RequestMethod.POST,
            params: payload,
        });
    }

    // 세션 단건 조회
    static onGetSession = (sessionId: number | string) => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/sessions/${sessionId}`,
            method: RequestMethod.GET,
        });
    }

    // 내가 귀가자인 활성 세션
    static onGetActiveSessionsAsTraveler = () => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/sessions/active/me`,
            method: RequestMethod.GET,
        });
    }

    // 모임의 활성 세션 목록
    static onGetActiveSessionsByMeeting = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/sessions/by-meeting/${meetingId}`,
            method: RequestMethod.GET,
        });
    }

    // 나에게 온 watch 요청 (INVITED)
    static onGetInvitedWatchRequests = () => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/watch/invited`,
            method: RequestMethod.GET,
        });
    }

    // 내가 지켜보고 있는 세션 (ACCEPTED)
    static onGetAcceptedWatchedSessions = () => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/watch/accepted`,
            method: RequestMethod.GET,
        });
    }

    // Watch 수락
    static onAcceptWatch = (sessionId: number | string) => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/sessions/${sessionId}/watch/accept`,
            method: RequestMethod.POST,
        });
    }

    // Watch 거절
    static onDeclineWatch = (sessionId: number | string) => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/sessions/${sessionId}/watch/decline`,
            method: RequestMethod.POST,
        });
    }

    // 귀가자 본인이 취소
    static onCancelSession = (sessionId: number | string) => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/sessions/${sessionId}/cancel`,
            method: RequestMethod.POST,
        });
    }

    // 귀가자 위치 보고
    static onReportLocation = (sessionId: number | string, payload: { lat: number; lng: number }) => {
        return onRequest({
            url: `${getApiUrl('safeReturn')}/sessions/${sessionId}/location`,
            method: RequestMethod.POST,
            params: payload,
        });
    }
}
